// Generates local paths to project and category pages
export const getPath = (title) => title.toLowerCase().replace(/ /g,"_");